import {
  FormField,
  FormField2,
  IControlField,
  IDynamicFormValue,
  IMultiSelectControlField,
  MultiSelectControlField,
  TextControlField
} from '../types';
import { IFieldResponse } from '../types/control-field.base';
import {
  DateRangeControlField,
  IDateRangeControlField
} from '../types/date-range-field';
import { IDateTypeControlField, toDateTypeField } from '../types/date-field';
import {
  INumberControlField,
  toNumberField
} from '../types/number-control-field';
import {
  IMultiSelectControlField2,
  ISelectOption,
  toSelectField
} from '../types/select-control-field';
import { toTextAreaField } from '../types/text-area-field';
import {
  ITextControlField,
  ITextControlField2,
  toTextField
} from '../types/textbox-control-field';
import { toToggleField } from '../types/toggle-control-field';
import dateTypeFieldValidation from '../validations/date-type-field.validations';
import numberFieldValidation from '../validations/number-field.validation';
import selectValidationSchema from '../validations/select-field.validations';
import textFieldValidation from '../validations/text-field.validations';
import { toSliderField } from '../types/slider-input-field';

export default function toFormFields(controls: IControlField[]): FormField[] {
  return controls.map((field) => {
    switch (field.control_type) {
      case 'TEXT':
        return new TextControlField(field as ITextControlField);

      case 'MULTISELECT-DROPDOWN':
        return new MultiSelectControlField(field as IMultiSelectControlField);

      case 'DATE-RANGE':
        return new DateRangeControlField(field as IDateRangeControlField);

      default:
        throw new Error(`Invalid control_type - ${field.control_type} passed`);
    }
  });
}

export function toFormFields2(controls: IFieldResponse[] | any): FormField2[] {
  return controls.map((field) => {
    switch (field.control_type) {
      case 'MULTISELECT-DROPDOWN':
        return toSelectField(field, true);

      case 'SINGLESELECT-DROPDOWN':
        return toSelectField(field);

      case 'TEXT':
        return toTextField(field);

      case 'NUMBER':
      case 'PERCENTAGE':
        return toNumberField(field);

      case 'TEXT-AREA':
        return toTextAreaField(field);

      case 'TOGGLE':
        return toToggleField(field);

      case 'DATE-RANGE':
        return toDateTypeField(field);

      case 'SLIDER-INPUT':
        return toSliderField(field);

      default:
        throw new Error(`Invalid control_type - ${field.control_type} passed`);
    }
  });
}

export function getDefaultValues(fields: FormField2[]) {
  return fields.reduce<IDynamicFormValue>((prev, curr) => {
    switch (curr.control_type) {
      case 'MULTISELECT-DROPDOWN':
      case 'SINGLESELECT-DROPDOWN':
        return {
          ...prev,
          [curr.name]: (
            curr as IMultiSelectControlField2
          ).values.map<ISelectOption>((option) => ({
            label: option.label,
            value: option.value
          }))
        };

      case 'TOGGLE':
        return {
          ...prev,
          [curr.name]: true
        };

      default:
        return {
          ...prev,
          [curr.name]: ''
        };
    }
  }, {});
}

export function getValidationSchema(
  field: FormField2,
  showErrorMessage = true
) {
  switch (field.control_type) {
    case 'MULTISELECT-DROPDOWN':
    case 'SINGLESELECT-DROPDOWN':
      return selectValidationSchema(field, showErrorMessage);

    case 'TEXT':
      return textFieldValidation(field as ITextControlField2);

    case 'NUMBER':
      return numberFieldValidation(field as INumberControlField);

    case 'PERCENTAGE':
      return numberFieldValidation(field as INumberControlField);

    case 'DATE-RANGE':
      return dateTypeFieldValidation(field as IDateTypeControlField);

    default:
      return {};
  }
}
